<div class="modal-header">
  <h5 class="modal-title">New Broker User</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="card text-black" [ngClass]="{'blur-background' : loading}">
  <i class="fab fa-apple fa-lg pt-3 pb-1 px-3"></i>
  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"
       class="rounded-circle img-fluid" style="width: 100px;align-self: center;"/>
  <div class="card-body text-center">
    <h4 class="mb-2" style="font-weight: bold;">{{firstName}} {{ lastName}}</h4>
    <p class="text-muted mb-4">&#64;<a>{{company}}</a></p>


  </div>
  <div class="card-body">
    <div>
      <div class="d-flex justify-content-between">
        <span>Email Address</span><span>{{email}}</span>
      </div>
      <div class="d-flex justify-content-between mt-3">
        <span>Contact Number</span><span>{{contactNo}}</span>
      </div>
      <div class="d-flex justify-content-between mt-3">
        <span>Username</span><span>{{username}}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4" *ngIf="userrole !== 5" >
      <span class="font-weight-bold">Role</span>
      <div class="col-6 p-0">
        <select class="form-select" required [(ngModel)]="selectedRole">
          <option value="brokerAdmin" >Admin User</option>
          <option value="normalBroker">Normal User</option>

        </select>

      </div>
    </div>

    <div class="d-flex justify-content-between" *ngIf="userrole === 5">
      <span>Role</span><span>{{selectedRole}}</span>
    </div>


    <div class="col-6 mb-3">
      <h6>Preferred APIs</h6>
      <div class="general-checkBox" >
        <input type="checkbox" id="GtnApiEnableCheck" ng-model="check" [(ngModel)]="openAPIEnabled"/>
        GTN Fintech APIs
      </div>
      <div class="general-checkBox" >
        <input type="checkbox" id="EmbedApiEnableCheck" ng-model="check" [(ngModel)]="embedAPIEnabled"/>
        GTN Embed APIs
      </div>
      <div class="general-checkBox" >
        <input type="checkbox" id="AccountApiEnableCheck" ng-model="check" [(ngModel)]="backOfficeAPIEnabled"/>
        GTN Backoffice APIs
      </div>
      <div class="general-checkBox" >
        <input type="checkbox" id="DwmApiEnableCheck" ng-model="check" [(ngModel)]="dwmAPIEnabled"/>
        GTN DWM APIs
      </div>
      <div class="general-checkBox" >
        <input type="checkbox" id="FeedApiEnableCheck" ng-model="check" [(ngModel)]="feedAPIEnabled"/>
        GTN Market Data APIs
      </div>
    </div>


    <div class="d-flex justify-content-between mt-4" >
      <span class="font-weight-bold">Region</span>
      <div class="col-6 p-0">
        <select class="form-select" required [(ngModel)]="region" (change)="enableInstitutionSelectBox($event)">
          <option value="asia">ASIA</option>
          <option value="mena">MENA</option>
          <option value="global sandbox">GLOBAL SANDBOX</option>
        </select>
<!--        <div *ngIf="submitted && institutionId == -1" class="text-danger mt-1">-->
<!--          Select a region-->
<!--        </div>-->
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4" >
      <span class="font-weight-bold">Institution</span>
      <div class="col-6 p-0">
        <select [disabled]= isDisabled class="form-select" required [(ngModel)]="institutionId" size='1' onfocus='if (this.options.length > 5){this.size = 5}' onblur="this.size = 1" onchange='this.size = 1;  this.blur();'>
          <option value="-1" disabled selected hidden>Select Institute</option>

          <option
                  [hidden]="region=='mena'"
                  [ngValue]="institution.institutionId"
                  *ngFor="let institution of institutions">{{institution.institution}}</option>

          <option
            [hidden]="region=='asia'"
            [ngValue]="institution.institutionId"
            *ngFor="let institution of difcInstitutions">{{institution.institution}}</option>

          <option
            [hidden]="region=='global sandbox'"
            [ngValue]="institution.institutionId"
            *ngFor="let institution of difcInstitutions">{{institution.institution}}</option>

        </select>
        <div *ngIf="submitted && institutionId == -1" class="text-danger mt-1">
          Select a institution
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      Close
    </button>
    <button type="button" class="btn btn-primary" (click)="onUserAprrove()">Done</button>
  </div>
</div>
